import { InformationCircleIcon } from '@heroicons/react/24/outline'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { StyleSheet, View } from '../compiler'

import MandatoryBadge from '../../../../features/discover/components/evaluation/MandatoryBadge'
import { isSet } from '../../../../helpers'
import { typoStyles } from '../constants'
import { useTranslationContext } from '../context/general-translations'
import BeamGraph from './graphs/BeamGraph'
import MarkdownText from './MarkdownText'

const styles = StyleSheet.create({
  dimensionTop: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 24,
    height: 72,
    backgroundColor: '#fff',
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    borderLeftWidth: 1,
    borderTopWidth: 1,
    borderRightWidth: 1,
    borderColor: '#EBF0F5'
  },
  dimensionBottom: {
    borderTopWidth: 1,
    backgroundColor: '#FAFBFC',
    padding: 24,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
    borderLeftWidth: 1,
    borderBottomWidth: 1,
    borderRightWidth: 1,
    borderColor: '#EBF0F5'
  }
})

/**
 * Dashboard-Abweichung gegenüber aivy-pdf-reports: isMandatory zeigt das
 * Muss-Badge wie im Passungsprofil, das Teamprofil setzt es bei gewählter Stelle.
 */
const DimensionCard = ({
  style = {},
  dimension = { property: {}, scaleEndpoints: {} },
  beamGraphData,
  description,
  language,
  title,
  endpointLeft,
  endpointRight,
  onClickDimensionTitle,
  joyrideTargetId,
  hasCompletedOnboarding = true,
  dimensionTitleJoyrideId,
  isMandatory = false,
  isLoading
}) => {
  const { tGeneral } = useTranslationContext()

  const { property, scaleEndpoints } = dimension
  const { left, right } = scaleEndpoints

  return (
    <View style={style}>
      <View style={styles.dimensionTop}>
        <View style={{ flexDirection: 'row', alignItems: 'flex-end' }}>
          <button
            disabled={!isSet(onClickDimensionTitle) || !hasCompletedOnboarding}
            onClick={onClickDimensionTitle}
            className='flex flex-row items-center gap-x-1'
            id={dimensionTitleJoyrideId}
          >
            <MarkdownText
              style={[
                typoStyles.H4Black,
                { textTransform: 'uppercase', textAlign: 'left' }
              ]}
            >
              {isLoading ? (
                <Skeleton width={150} />
              ) : (
                title || property[language]
              )}
            </MarkdownText>
            {isLoading ? (
              <Skeleton width={24} height={24} circle />
            ) : (
              onClickDimensionTitle && (
                <InformationCircleIcon className={`h-6 w-6 text-darkBlack`} />
              )
            )}
          </button>
          {!isLoading && isMandatory && (
            <MandatoryBadge className='ml-2 flex-shrink-0' />
          )}
          {!isLoading && beamGraphData.dataset_not_complete && (
            <MarkdownText
              style={[
                typoStyles.SmallBlack,
                { marginLeft: 4, paddingBottom: 1 }
              ]}
            >
              {tGeneral('dataset_not_complete')}
            </MarkdownText>
          )}
        </View>
        <View id={joyrideTargetId} style={{ width: 452 }}>
          {isLoading ? (
            <Skeleton height={40} />
          ) : (
            <BeamGraph title={title} {...beamGraphData} />
          )}
          <View
            style={{
              flexDirection: 'row',
              justifyContent: 'space-between',
              marginTop: 8
            }}
          >
            <MarkdownText style={typoStyles.SmallBlack}>
              {isLoading ? (
                <Skeleton width={80} />
              ) : (
                endpointLeft || left.title[language]
              )}
            </MarkdownText>
            <MarkdownText style={typoStyles.SmallBlack}>
              {isLoading ? (
                <Skeleton width={80} />
              ) : (
                endpointRight || right.title[language]
              )}
            </MarkdownText>
          </View>
        </View>
      </View>
      <View style={styles.dimensionBottom}>
        <MarkdownText
          style={[typoStyles.T1Black, { width: '75%', lineHeight: 1.5 }]}
        >
          {isLoading ? <Skeleton count={2} /> : description}
        </MarkdownText>
      </View>
    </View>
  )
}

export default DimensionCard
